// ─── Area Conversion Helpers ──────────────────────────────────────────────────
// Nepali land measurement: Ropani system (hilly)
// 1 Ropani = 16 Aana, 1 Aana = 4 Paisa, 1 Paisa = 4 Dam
// 1 Ropani = 508.72 sqm  (standard GoN value)
export const ROPANI_TO_SQM = 508.72;
export const AANA_TO_SQM   = ROPANI_TO_SQM / 16;   // 31.795
export const PAISA_TO_SQM  = AANA_TO_SQM   / 4;    //  7.949
export const DAM_TO_SQM    = PAISA_TO_SQM  / 4;    //  1.987

export function radpToSqm({ r=0, a=0, p=0, d=0 }) {
  return (parseFloat(r)||0)*ROPANI_TO_SQM
       + (parseFloat(a)||0)*AANA_TO_SQM
       + (parseFloat(p)||0)*PAISA_TO_SQM
       + (parseFloat(d)||0)*DAM_TO_SQM;
}

export function sqmToRadp(sqm) {
  let rem = parseFloat(sqm)||0;
  const r = Math.floor(rem / ROPANI_TO_SQM); rem -= r * ROPANI_TO_SQM;
  const a = Math.floor(rem / AANA_TO_SQM);   rem -= a * AANA_TO_SQM;
  const p = Math.floor(rem / PAISA_TO_SQM);  rem -= p * PAISA_TO_SQM;
  const d = Math.round(rem / DAM_TO_SQM);
  return { r, a, p, d };
}

export function sqmToAana(sqm) { return (parseFloat(sqm)||0) / AANA_TO_SQM; }
export function aanaToSqm(a)   { return (parseFloat(a)||0) * AANA_TO_SQM; }

// Get total sqm from a property's area fields
export function propAreaSqm(prop) {
  if (prop.areaUnit === "sqm")  return parseFloat(prop.areaSqm)||0;
  if (prop.areaUnit === "radp") return radpToSqm(prop.areaRadp||{});
  return 0;
}

// Display string for area
export function areaDisplay(prop) {
  if (prop.areaUnit === "sqm") {
    return `${parseFloat(prop.areaSqm)||0} sq.m`;
  }
  const { r,a,p,d } = prop.areaRadp||{};
  return `${r||0}-${a||0}-${p||0}-${d||0} (R-A-P-D)`;
}
